// extracted by mini-css-extract-plugin
export var cartContainer = "_m7-4";
export var gray = "_m7-1";
export var itemContainer = "_m7-2";
export var itemDetails = "_m7-3";
export var strong = "_m7-0";